import { parse as parseYaml } from 'yaml';
import { GroupSpec } from './FilterTypesSpec';
export var parseGroup = function (comment) {
    var declarationContent = comment.substring(comment.indexOf('\n'), // chop the structured declaration
    comment.indexOf('*/'));
    var groupYaml = parseYaml(declarationContent);
    return GroupSpec.parse(groupYaml);
};
